import type { SubscriptionPeriod } from "@/shared/components/PricingTable/types";

export function formatSubscriptionPeriod(period: SubscriptionPeriod): string {
	return period === "year" ? "Annual" : "Monthly";
}
